<!--
 * @Author: 范向玲
 * @Date: 2022-12-06 15:39:08
 * @LastEditTime: 2022-12-06 15:39:08
 * @LastEditors: 范向玲
 * @Description: 走势库数据管理--下载页
 * @FilePath: \src\components\ProjectPerformance\DataManager\detail.vue
-->
<template>
  <section class="trend-download-container">
    <section v-for="(arr, index) in option" :key="index" class="down-info-box">
      <section v-for="(info, infoIndex) in arr" :key="infoIndex" class="down-info-item">
        <section class="info-title">{{ info.name }}</section>
        <template v-if="info.type ==='checkbox'">
          <a-checkbox-group :class="info.children.length > 1 ? 'type-check-group' : 'type-check-group1'" v-model:value="info.selectValue">
            <a-checkbox :value="item.key" v-for="item in info.children" :key="item.key">{{ item.name }}</a-checkbox>
          </a-checkbox-group>
        </template>
        <template v-else-if="info.type ==='radio'">
          <a-radio-group class="type-radio-group" v-model:value="info.selectValue">
            <a-radio :value="item.key" v-for="item in info.children" :key="item.key">{{ item.name }}</a-radio>
          </a-radio-group>
        </template>
      </section>
    </section>
  </section>
</template>

<script setup>
import { defineProps, ref, watch, onBeforeUnmount, } from 'vue';
import config from '@/config/config';

const props = defineProps({
  option: {
    required: true,
  },
});

onBeforeUnmount(() => {
  // props.option.forEach(arr => {
  //   arr.forEach(item => {
  //     item.selectValue = item.valueType === 'arr' ? [] : '';
  //   });
  // });
});

</script>

<style lang="scss">
:deep(.default1-modal) {
  .ant-modal-content {
    width: 7rem;
  }
}
.trend-download-container {
  color: #Fff;
  .down-info-box {
    border: 1px solid #695933;
    margin-bottom: 0.05rem;
    .down-info-item {
      display: flex;
      .info-title {
        color: #FEB500;
        font-size: 0.16rem;
        // font-weight: bold;
        width: 1rem;
        margin: 0.05rem 0 0 0.1rem;
      }
      /* 多选组件 */
      .type-check-group {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;

        .ant-checkbox-wrapper {
          width: 25%;
          color: #fff;
          margin-left: 0;
          margin: .1rem 0 ;
        }
      }
      .type-check-group1 {
        .ant-checkbox-wrapper {
          // width: 25%;
          color: #fff;
          margin-left: 0;
          margin: .1rem 0 ;
        }
      }
      /* 单选组件 */
      .type-radio-group {
        .ant-radio-wrapper {
          color: #fff;
          margin-left: 0;
          margin: .1rem 0 ;
        }
      }
    }
  }
}
</style>